import type {
  SyncContractItemsMutationOptions,
  SyncContractItemsVariables,
} from './types';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import { queryKeysContract } from '../queryKeys';

import { syncContractItems } from './syncContractItems';

/**
 * Synchronizes the complete active item set of a draft contract atomically.
 *
 * @param options - Additional mutation options.
 * @returns The contract-item sync mutation.
 * @see https://app.dev.vestigas.com/redoc#tag/Contracts/operation/sync_contract_items_contracts__contract_id__items_sync_post
 */
export const useMutationSyncContractItems = (
  options?: SyncContractItemsMutationOptions,
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ contractId, payload }: SyncContractItemsVariables) =>
      syncContractItems(contractId, payload),
    onSuccess(_data, { contractId }) {
      void queryClient.invalidateQueries({
        queryKey: queryKeysContract.get(contractId),
      });
      void queryClient.invalidateQueries({
        queryKey: queryKeysContract.getAll(undefined),
      });
      void queryClient.invalidateQueries({
        queryKey: queryKeysContract.getItems(contractId, undefined),
      });
    },
    ...options,
  });
};
